import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { BaseFilterComponent } from '../base-filter.component';
import { NumberFilterType } from '../../../../../core/services/api-services';
import { FilterType } from '../../../../../core/enums/filter-type';
import { Filter } from '../../../../../core/models/filter';

@Component({
  selector: 'app-number-filter',
  templateUrl: './number-filter.component.html',
  styleUrls: ['./number-filter.component.scss']
})
export class NumberFilterComponent extends BaseFilterComponent<NumberFilterType> implements OnInit {
  filterForm = new FormGroup({
    filterType: new FormControl<NumberFilterType>(NumberFilterType.Equals, [Validators.required])
  });

  numberBetweenForm = new FormGroup({
    value: new FormControl('', Validators.required),
    value2: new FormControl('', Validators.required)
  });

  singleNumberForm = new FormGroup({
    value: new FormControl('', Validators.required),
    value2: new FormControl(null)
  });

  filterOptions = this.getFilterOptions();
  currentFilter = new BehaviorSubject<NumberFilterType>(NumberFilterType.Equals);
  numberFilterBetween = NumberFilterType.Between;
  numberFilterType = NumberFilterType;
  filterType: FilterType = FilterType.Number;

  constructor(
    private readonly formBuilder: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.currentValue
      .unsubscribeOnDestroy(this)
      .subscribe(value => {
        if (value) {
          this.filterChanged.emit({ filter: value, filterType: this.filterType, propertyName: this.propertyName });
          this.activeFilterField = value !== null;

          this.filterTypeControl.setValue(value.filterType);

          if (value.filterType !== NumberFilterType.Between) {
            this.numberSingleNumberControl.setValue(value.values[0]);
          }
          else {
            this.numberBetweenValueControl.setValue(value.values[0]);
            this.numberBetweenValue2Control.setValue(value.values[1]);
          }
        }
      });

    if (this.initialValue) {
      this.currentValue.next(this.initialValue);
    }
  }

  clearFilter(): void {
    this.currentValue.next(null);
    this.activeFilterField = this.currentValue.value !== null;
    this.filterForm.reset();
    this.numberBetweenForm.reset();
    this.singleNumberForm.reset();
  }

  getFilterOptions(): { value: number, translationKey: string }[] {
    const options: { value: number, translationKey: string }[] = [];

    Object.keys(NumberFilterType).filter((enumVal) => !isNaN(Number(enumVal))).forEach((enumVal: any) => {
      options.push({
        value: parseInt(enumVal, 10),
        translationKey: `GridTable.Filter.NumberFilters.${NumberFilterType[enumVal]}`
      });
    });

    return options;
  }

  onFilterChange($event: MatSelectChange): void {
    this.currentFilter.next($event.value as NumberFilterType);
  }

  onSubmit($event): void {
    if (this.currentFilter.value !== NumberFilterType.Between) {
      // Trigger form validation for untouched fields
      this.singleNumberForm.markAllAsTouched();

      if (this.singleNumberForm.valid) {
        const model: Filter<NumberFilterType> = {
          filterType: this.filterTypeControl.value,
          values: [this.numberSingleNumberControl.value, null] as any[],
          name: this.propertyName
        };

        this.currentValue.next(model);
      }
      else {
        $event?.stopPropagation();
      }
    } else {
      // Trigger form validation for untouched fields
      this.numberBetweenForm.markAllAsTouched();

      if (this.numberBetweenForm.valid) {
        const model: Filter<NumberFilterType> = {
          filterType: this.currentFilter.value,
          values: [this.numberBetweenValueControl.value, this.numberBetweenValue2Control.value] as any[],
          name: this.propertyName
        };

        this.currentValue.next(model);
      }
      else {
        $event?.stopPropagation();
      }
    }
  }

  onCancel(): void {
  }

  get numberSingleNumberControl(): FormControl {
    return this.singleNumberForm.controls.value as FormControl;
  }

  get numberBetweenValueControl(): FormControl { // TODO: What is this even used for?
    return this.numberBetweenForm.controls.value as FormControl;
  }

  get numberBetweenValue2Control(): FormControl {
    return this.numberBetweenForm.controls.value2 as FormControl;
  }

  get filterTypeControl(): FormControl {
    return this.filterForm.controls.filterType as FormControl;
  }
}
